@if (sources.length) {
    <div class="inline">
        @defer (hydrate never) {
            <picture>
                @for (source of sources; track trackBy($index, source)) {
                    <source
                        [attr.srcset]="lazy ? null : source.srcSet || ''"
                        [attr.data-srcset]="lazy ? source.srcSet || '' : null"
                        [media]="source.mediaQuery" />
                }

                <img
                    class="w-full bg-lightergrey"
                    [attr.src]="lazy ? null : fallback?.defaultSrc"
                    [attr.data-src]="lazy ? fallback?.defaultSrc : null"
                    [attr.fetchPriority]="preload ? 'high' : 'low'"
                    [alt]="alt || configurations[stops.FALLBACK]?.alt"
                    [ngClass]="cssClasses" />
            </picture>
        }
    </div>
}
